import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

import { CompanyInterface } from '../company.interface'

export const CompanyValidationSchema = () => {
  const { t } = useTranslation()

  return yup.object<CompanyInterface>({
    companyName: yup.string().required(t('auth.register.errors.companyRequired')),
    companyInn: yup.string().required(t('auth.register.errors.companyInnRequired')),
    companyOgrn: yup.string().required(t('auth.register.errors.companyOgrnRequired')),
  })
}
